import _get from 'lodash/get';
import { setLocale as setYupLocale } from 'yup';

let currentLanguageCode = '';

const languages: {
  [key: string]: {
    id: string;
    label: string;
    flag: string;
    dictionary: any;
  };
} = {
  en: {
    id: 'en',
    label: 'English',
    flag: '/images/flags/United-States.png',
    dictionary: null,
  },
  'es-ES': {
    id: 'es-ES',
    label: 'Español',
    flag: '/images/flags/Spain.png',
    dictionary: null,
  },
  'pt-BR': {
    id: 'pt-BR',
    label: 'Português',
    flag: '/images/flags/Brazil.png',
    dictionary: null,
  },
};

export async function init() {
  currentLanguageCode =
    localStorage.getItem('language') || 'es-ES';
  setLanguageCode(currentLanguageCode);

  if (currentLanguageCode === 'en') {
    await initEn();
  }

  if (currentLanguageCode === 'pt-BR') {
    await initPtBr();
  }

  if (currentLanguageCode === 'es-ES') {
    await initEs();
  }
}

async function initPtBr() {
  const language = languages['pt-BR'];

  language.dictionary = (
    await import('src/i18n/pt-BR')
  ).default;

  if (language.dictionary.validation) {
    setYupLocale(language.dictionary.validation);
  }

  return language;
}

async function initEs() {
  const language = languages['es-ES'];

  language.dictionary = (
    await import('src/i18n/es-ES')
  ).default;

  if (language.dictionary.validation) {
    setYupLocale(language.dictionary.validation);
  }

  return language;
}

async function initEn() {
  const language = languages['en'];

  language.dictionary = (
    await import('src/i18n/en')
  ).default;

  if (language.dictionary.validation) {
    setYupLocale(language.dictionary.validation);
  }

  return language;
}

function getLanguage() {
  return languages[getLanguageCode()];
}

function format(message: string, args: any[]) {
  if (!message) {
    return null;
  }

  try {
    return message.replace(
      /{(\d+)}/g,
      function (match, number) {
        return typeof args[number] != 'undefined'
          ? args[number]
          : match;
      },
    );
  } catch (error) {
    console.error(message, error);
    throw error;
  }
}

export function getLanguages() {
  return Object.keys(languages).map((language) => {
    return languages[language];
  });
}

export function getLanguageCode() {
  return currentLanguageCode;
}

export function setLanguageCode(arg: string) {
  if (!languages[arg]) {
    localStorage.setItem('language', 'es-ES');
    throw new Error(`Invalid language ${arg}.`);
  }

  localStorage.setItem('language', arg);
  currentLanguageCode = arg;
}

export function i18nExists(key: string | null) {
  if (!key || !getLanguage()) {
    return false;
  }

  const message = _get(getLanguage().dictionary, key);
  return Boolean(message);
}

export function i18n(key: any, ...args: any[]) {
  if (!key || !getLanguage()) {
    return key ?? '';
  }

  const message = _get(getLanguage().dictionary, key);

  if (!message) {
    return key;
  }

  return format(message, args);
}

export function i18nHtml(key: string | null, ...args: any[]) {
  return (
    <span
      dangerouslySetInnerHTML={{
        __html: i18n(key, ...args) ?? '',
      }}
    />
  );
}
